export default "__VITE_ASSET__9fbc655e__"